import styled from 'styled-components';
import { DeprecatedGrid as Grid, Button } from '@simplywallst/ui-core';
import { SubSectionHeader } from '../../Overview/components/SubSectionHeader';

export const StyledHeaderGrid = styled(Grid)`
  ${SubSectionHeader} {
    margin: 0;
  }
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const NotesContainer = styled(Grid)`
  grid-template-rows: auto;
  max-height: 164px;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const NotesSidebarList = styled('div')`
  margin-top: ${({ theme }) => theme.safeAreaInsetTop};
  overflow: auto;
  height: 100%;
`;

export const SidebarHeader = styled(Grid)`
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const AddButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.color.brand01};
  ${({ theme }) => theme.typography.xSmall}
  > svg {
    fill: ${({ theme }) => theme.color.brand01};
    height: 16px;
    width: 16px;
  }
`;
